import React, { useState, useEffect } from 'react'
import ConfigBillingGeneralConfig from './ConfigBillingGeneralConfig'
import ConfigBillingPaymentMethods from './ConfigBillingPaymentMethods'
import ConfigBillingServices from './ConfigBillingServices'
import ConfigBillingPermissions from './ConfigBillingPermissions'

const ConfigBilling = (props) => {
  const {
    supportedServiceConfigs,
    supportedPaymentMethods,
    enableBillingService,
    setEnableBillingService,
    defaultAccountType,
    setDefaultAccountType,
    postpaidInvoiceType,
    setPostpaidInvoiceType,
    postpaidInvoicePayPeriod,
    setPostpaidInvoicePayPeriod,
    allowPublicCalculator,
    setAllowPublicCalculator,
    currency,
    setCurrency,
    enableVat,
    setEnableVat,
    pricesIncludeVat,
    setPricesIncludeVat,
    vatTax,
    setVatTax,
    paymentMethods,
    setPaymentMethods,
    selectedBackendServices,
    backendUserData,
    setBackendUserData,
    getRegionConfig,
    backendIsIdentityProviderSelected,
    billingServicesConfigurable,
    billingPermissions,
    setBillingPermissions,
    getDefaultBillingPermissions,
    errors,
    setErrors,
    submitted,
    validateFormFields,
    appCredentialSecret,
    setAppCredentialSecret,
    paymentMethodIds,
    setPaymentMethodIds,
  } = props

  const [availablePaymentMethods, setAvailablePaymentMethods] = useState([])

  useEffect(() => {
    if (currency) {
      let payment_methods = []

      supportedPaymentMethods.forEach(item => {
        const currency_object = item.currencies.find(item2 => item2.name === currency)
        if (currency_object) {
          payment_methods.push(item)
        }
      })

      setAvailablePaymentMethods(payment_methods)
    } else {
      setAvailablePaymentMethods([])
    }
  }, [supportedPaymentMethods, currency])

  useEffect(() => {
    if (availablePaymentMethods.length > 0) {
      setPaymentMethods(prev => {
        let updated_payment_methods = []
  
        prev.forEach(item => {
          const available_method = availablePaymentMethods.find(item2 => item2.name === item.name)
          if (available_method) {
            updated_payment_methods.push(item)
          }
        })
  
        return updated_payment_methods
      })
    }    
  }, [availablePaymentMethods, setPaymentMethods])
  
  return (
    <>
      <ConfigBillingGeneralConfig
        supportedPaymentMethods={supportedPaymentMethods}
        enableBillingService={enableBillingService}
        setEnableBillingService={setEnableBillingService}
        defaultAccountType={defaultAccountType}
        setDefaultAccountType={setDefaultAccountType}
        postpaidInvoiceType={postpaidInvoiceType}
        setPostpaidInvoiceType={setPostpaidInvoiceType}
        postpaidInvoicePayPeriod={postpaidInvoicePayPeriod}
        setPostpaidInvoicePayPeriod={setPostpaidInvoicePayPeriod}
        allowPublicCalculator={allowPublicCalculator}
        setAllowPublicCalculator={setAllowPublicCalculator}
        currency={currency}
        setCurrency={setCurrency}
        enableVat={enableVat}
        setEnableVat={setEnableVat}
        pricesIncludeVat={pricesIncludeVat}
        setPricesIncludeVat={setPricesIncludeVat}
        vatTax={vatTax}
        setVatTax={setVatTax}
        errors={errors}
        setErrors={setErrors}
        submitted={submitted}
        validateFormFields={validateFormFields}
      />

      {
        availablePaymentMethods.length > 0 &&
        <ConfigBillingPaymentMethods
          availablePaymentMethods={availablePaymentMethods}
          paymentMethods={paymentMethods}
          setPaymentMethods={setPaymentMethods}
          paymentMethodIds={paymentMethodIds}
          setPaymentMethodIds={setPaymentMethodIds}
        />
      }      

      <ConfigBillingServices
        supportedServiceConfigs={supportedServiceConfigs}
        selectedBackendServices={selectedBackendServices}
        backendUserData={backendUserData}
        setBackendUserData={setBackendUserData}
        getRegionConfig={getRegionConfig}
        backendIsIdentityProviderSelected={backendIsIdentityProviderSelected}
        billingServicesConfigurable={billingServicesConfigurable}
        errors={errors}
        setErrors={setErrors}
        submitted={submitted}
        validateFormFields={validateFormFields}
        appCredentialSecret={appCredentialSecret}
        setAppCredentialSecret={setAppCredentialSecret}
      />

      <ConfigBillingPermissions
        billingPermissions={billingPermissions}
        setBillingPermissions={setBillingPermissions}
        getDefaultBillingPermissions={getDefaultBillingPermissions}
      />
    </>
  )
}

export default ConfigBilling